import { createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Enums.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Companion_instance13way2il9a8jt as Companion_instance,
  Enum3alwj03lh1n41 as Enum,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { enumEntries20mr21zbe3az4 as enumEntries } from '../../../../../../kotlin-kotlin-stdlib/kotlin/enums/EnumEntries.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { SerializerFactory1qv9hivitncuv as SerializerFactory } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  toString30pk9tzaqopn as toString,
  arrayOf1akklvh2at202 as arrayOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  IDqqik72jjbpsn as ID,
  ID1lyj7m2ox8cp5 as ID_0,
  IDjecfjjw6mot9 as ID_1,
  ID1z61wlmtvxrjn as ID_2,
  ID1m87d1hextx54 as ID_3,
  Family2k7vz7ddyergb as Family,
  CareLocation1v3u5wduz023s as CareLocation,
  CareProvider2qcawrqluyllr as CareProvider,
  Employer27b20p5x27kte as Employer,
  Grant2zfdfpt9q1mly as Grant,
  ID2llykdzmszlol as ID_4,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/domain.mjs';
import { getValue48kllevslyh6 as getValue } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import {
  plus310ted5e4i90h as plus,
  toSet2orjxp16sotqu as toSet,
  sortedWith2csnbbb21k0lg as sortedWith,
  joinToString1cxrrlmo0chqs as joinToString,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  listOfvhqybd2zx248 as listOf,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  emptyList1g2z5xcrvp2zy as emptyList,
  listOfNotNull2woi2boe01ub4 as listOfNotNull,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual2mm942ha7plg6 as serializerOrContextual } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf18kqeagzkbefr as DataClassPathSelf } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import {
  get__id336i6k806byxy as get__id,
  get__id2p9nbcwbj0zlw as get__id_0,
  get__id1301miildb0kq as get__id_1,
  get__id1hi7gtah39onn as get__id_2,
  get__idsxxkn2fqoor7 as get__id_3,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/ModelFields-372156621.mjs';
import { xDataClassPathInsideSet2a49hafkm1zud as xDataClassPathInsideSet } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ConditionBuilder.mjs';
import { Queryam9ckqg1rxkb as Query } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Query.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { addAll1k27qatfgp3k5 as addAll } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import {
  await1xlt6i5aa076q as await_0,
  await1uwe8zvsjq69o as await_1,
} from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_currentSessionNotNull30vuua77prq38 as get_currentSessionNotNull } from '../../sdk/currentSession.mjs';
import { asyncz02dsa2nb2zt as async } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import {
  Triple1vhi3d0dgpnjb as Triple,
  to2cs3ny02qtbcb as to,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { compareBy2697bq0ffft96 as compareBy } from '../../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import { coroutineScope2qhrb6lhutwsn as coroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import {
  Companion_instance1lm8x0jadqh2g as Companion_instance_0,
  Platform_Web_getInstance2840w5bkfolz8 as Platform_Web_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.mjs';
import { get_current2r182tjucmm5v as get_current } from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.js.mjs';
import {
  Signal1973xs1vkmdcb as Signal,
  _Constant___init__impl__v45mub2qfk15kh5l39c as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  ReportFiltersigb451dg4asm as ReportFilters,
  reportFilterMenu2u8jz7auzgjn6 as reportFilterMenu,
  reportFilterBar2ow9csmm0mu97 as reportFilterBar,
} from './ReportFilters.mjs';
import { get_scrolling3fwkltztkpfe8 as get_scrolling } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { maxWidth22r11xnm7d4h4 as maxWidth } from '../components/view-utilities.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import {
  ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement,
  Companion_getInstanceztgx4sy4wjnt as Companion_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { get_atBottomStart1iulwjfo1udg3 as get_atBottomStart } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  weight31wqab1913ly4 as weight,
  shownWhen3t7othivfr11 as shownWhen,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { h12aidul0n4qlwh as h1 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { LabeledViewseav57tyecmf as LabeledView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/labels.mjs';
import { FieldSemantic_getInstancer1p3l15xmphu as FieldSemantic_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { Select2osqjs95yxuh6 as Select } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Select.commonHtml.mjs';
import { rememberSuspending14xvgr29y3z54 as rememberSuspending } from '../../../../../../reactive/com/lightningkite/reactive/core/RememberSuspending.mjs';
import {
  Companion_instance35wmauq2koet0 as Companion_instance_1,
  tablezpetcq9vbay1 as table,
} from '../components/table.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { Page1o437w9xuocrm as Page } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function _get_$cachedSerializer__te6jhj($this) {
  return $this.$cachedSerializer$delegate_1.get_value_j01efc_k$();
}
function PlacementGrouping$Companion$_anonymous__krj93b() {
  return createSimpleEnumSerializer('org.thecommunitygroupinc.cares.views.reports.PlacementGrouping', values());
}
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  PlacementGrouping_Payer_instance = new (PlacementGrouping())('Payer', 0, 'Payer');
  PlacementGrouping_Family_instance = new (PlacementGrouping())('Family', 1, 'Family');
  PlacementGrouping_AgeGroup_instance = new (PlacementGrouping())('AgeGroup', 2, 'Age group');
  PlacementGrouping_Location_instance = new (PlacementGrouping())('Location', 3, 'Location');
  PlacementGrouping_Provider_instance = new (PlacementGrouping())('Provider', 4, 'Provider');
  PlacementGrouping_LocationType_instance = new (PlacementGrouping())('LocationType', 5, 'Location type');
  if (Companion_instance_2 === VOID) {
    Companion_instance;
    new (Companion())();
  }
}
var PlacementGrouping_Payer_instance;
var PlacementGrouping_Family_instance;
var PlacementGrouping_AgeGroup_instance;
var PlacementGrouping_Location_instance;
var PlacementGrouping_Provider_instance;
var PlacementGrouping_LocationType_instance;
function values() {
  static_init();
  return [PlacementGrouping_Payer_getInstance(), PlacementGrouping_Family_getInstance(), PlacementGrouping_AgeGroup_getInstance(), PlacementGrouping_Location_getInstance(), PlacementGrouping_Provider_getInstance(), PlacementGrouping_LocationType_getInstance()];
}
function get_entries() {
  static_init();
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_2 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.$cachedSerializer$delegate_1 = lazy(tmp_0, PlacementGrouping$Companion$_anonymous__krj93b);
      }
      serializer_9w0wvi_k$() {
        return _get_$cachedSerializer__te6jhj(this);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_9w0wvi_k$();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_2;
function Companion_getInstance_0() {
  static_init();
  return Companion_instance_2;
}
var $ENTRIES;
var PlacementGroupingClass;
function PlacementGrouping() {
  if (PlacementGroupingClass === VOID) {
    class $ extends Enum() {
      constructor(name, ordinal, displayName) {
        super(name, ordinal);
        this.displayName_1 = displayName;
      }
    }
    initMetadataForClass($, 'PlacementGrouping', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_0});
    PlacementGroupingClass = $;
  }
  return PlacementGroupingClass;
}
var RowClass;
function Row() {
  if (RowClass === VOID) {
    class $ {
      constructor(label, placements, children) {
        this.label_1 = label;
        this.placements_1 = placements;
        this.children_1 = children;
      }
      toString() {
        return 'Row(label=' + this.label_1 + ', placements=' + this.placements_1 + ', children=' + this.children_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.label_1);
        result = imul(result, 31) + this.placements_1 | 0;
        result = imul(result, 31) + this.children_1 | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Row()))
          return false;
        if (!(this.label_1 === other.label_1))
          return false;
        if (!(this.placements_1 === other.placements_1))
          return false;
        if (!(this.children_1 === other.children_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Row');
    RowClass = $;
  }
  return RowClass;
}
var PlacementTotalsPage$render$GroupClass;
function PlacementTotalsPage$render$Group() {
  if (PlacementTotalsPage$render$GroupClass === VOID) {
    class $ {
      constructor(label, order, id) {
        order = order === VOID ? 0 : order;
        id = id === VOID ? null : id;
        this.label_1 = label;
        this.order_1 = order;
        this.id_1 = id;
      }
      toString() {
        return 'Group(label=' + this.label_1 + ', order=' + this.order_1 + ', id=' + toString(this.id_1) + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.label_1);
        result = imul(result, 31) + this.order_1 | 0;
        result = imul(result, 31) + (this.id_1 == null ? 0 : hashCode(this.id_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PlacementTotalsPage$render$Group()))
          return false;
        if (!(this.label_1 === other.label_1))
          return false;
        if (!(this.order_1 === other.order_1))
          return false;
        if (!equals(this.id_1, other.id_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Group');
    PlacementTotalsPage$render$GroupClass = $;
  }
  return PlacementTotalsPage$render$GroupClass;
}
function render$groupsOf(families, f, locations, providers, employers, grants, p, grouping) {
  var tmp;
  switch (grouping.ordinal_1) {
    case 0:
      // Inline function 'kotlin.collections.map' call

      var this_0 = p.employers_1;
      // Inline function 'kotlin.collections.mapTo' call

      var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
      var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
      while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
        var item = _iterator__ex2g4s.next_20eer_k$();
        var it = item.raw_1;
        var tmp$ret$2 = new (PlacementTotalsPage$render$Group())(getValue(employers, new (ID())(it)).name_1, VOID, new (ID())(it));
        destination.add_utx5q5_k$(tmp$ret$2);
      }

      var tmp_0 = destination;
      // Inline function 'kotlin.collections.map' call

      var this_1 = p.grants_1;
      // Inline function 'kotlin.collections.mapTo' call

      var destination_0 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_1, 10));
      var _iterator__ex2g4s_0 = this_1.iterator_jk1svi_k$();
      while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
        var item_0 = _iterator__ex2g4s_0.next_20eer_k$();
        var it_0 = item_0.raw_1;
        var tmp$ret$5 = new (PlacementTotalsPage$render$Group())(getValue(grants, new (ID_0())(it_0)).name_1, VOID, new (ID_0())(it_0));
        destination_0.add_utx5q5_k$(tmp$ret$5);
      }

      // Inline function 'kotlin.collections.ifEmpty' call

      var this_2 = plus(tmp_0, destination_0);
      var tmp_1;
      if (this_2.isEmpty_y1axqb_k$()) {
        tmp_1 = listOf(new (PlacementTotalsPage$render$Group())('No payer'));
      } else {
        tmp_1 = this_2;
      }

      tmp = tmp_1;
      break;
    case 1:
      tmp = listOf(new (PlacementTotalsPage$render$Group())(getValue(families, new (ID_1())(p.family_1)).get_distinctName_5wyy9c_k$(), VOID, new (ID_1())(p.family_1)));
      break;
    case 2:
      // Inline function 'kotlin.let' call

      var it_1 = f.ageGroupOf_ek8y4_k$(p);
      var tmp$ret$8 = new (PlacementTotalsPage$render$Group())(it_1.displayName_1, it_1.ordinal_1);
      tmp = listOf(tmp$ret$8);
      break;
    case 3:
      tmp = listOf(new (PlacementTotalsPage$render$Group())(getValue(locations, new (ID_2())(p.location_1)).name_1, VOID, new (ID_2())(p.location_1)));
      break;
    case 4:
      tmp = listOf(new (PlacementTotalsPage$render$Group())(getValue(providers, new (ID_3())(p.provider_1)).name_1, VOID, new (ID_3())(p.provider_1)));
      break;
    case 5:
      // Inline function 'kotlin.let' call

      var it_2 = getValue(locations, new (ID_2())(p.location_1)).type_1;
      var tmp$ret$10 = new (PlacementTotalsPage$render$Group())(it_2.displayName_1, it_2.ordinal_1);
      tmp = listOf(tmp$ret$10);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function PlacementTotalsPage$render$lambda(it) {
  return it.displayName_1;
}
function PlacementTotalsPage$render$lambda_0(it) {
  var tmp1_elvis_lhs = it == null ? null : it.displayName_1;
  return tmp1_elvis_lhs == null ? 'Nothing' : tmp1_elvis_lhs;
}
function PlacementTotalsPage$render$slambda$slambda$slambda($api, $placements) {
  return constructCallableReference(($this$async, $completion) => orPromise($completion, function *($completion) {
    var tmp = $api.get_family_d7lffx_k$();
    var tmp2 = 2147483647;
    // Inline function 'com.lightningkite.services.database.Query' call
    // Inline function 'kotlin.collections.listOf' call
    var orderBy = emptyList();
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_0 = serializerOrContextual(createKType(getKClass(Family()), arrayOf([]), false));
    var tmp$ret$3 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
    var it = new (DataClassPathSelf())(tmp$ret$3);
    var tmp_1 = get__id(it);
    // Inline function 'kotlin.collections.map' call
    var this_0 = $placements;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var item = _iterator__ex2g4s.next_20eer_k$();
      var tmp$ret$7 = new (ID_1())(item.family_1);
      destination.add_utx5q5_k$(tmp$ret$7);
    }
    var tmp$ret$4 = xDataClassPathInsideSet(tmp_1, toSet(destination));
    var tmp$ret$0 = new (Query())(tmp$ret$4, orderBy, 0, tmp2);
    return yield* tmp.query_o986pg_k$(tmp$ret$0, $completion);
  }), 1);
}
function PlacementTotalsPage$render$slambda$slambda$slambda_0($api, $placements) {
  return constructCallableReference(($this$async, $completion) => orPromise($completion, function *($completion) {
    var tmp = $api.get_careLocation_drerzj_k$();
    var tmp2 = 2147483647;
    // Inline function 'com.lightningkite.services.database.Query' call
    // Inline function 'kotlin.collections.listOf' call
    var orderBy = emptyList();
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_0 = serializerOrContextual(createKType(getKClass(CareLocation()), arrayOf([]), false));
    var tmp$ret$3 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
    var it = new (DataClassPathSelf())(tmp$ret$3);
    var tmp_1 = get__id_0(it);
    // Inline function 'kotlin.collections.map' call
    var this_0 = $placements;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var item = _iterator__ex2g4s.next_20eer_k$();
      var tmp$ret$7 = new (ID_2())(item.location_1);
      destination.add_utx5q5_k$(tmp$ret$7);
    }
    var tmp$ret$4 = xDataClassPathInsideSet(tmp_1, toSet(destination));
    var tmp$ret$0 = new (Query())(tmp$ret$4, orderBy, 0, tmp2);
    return yield* tmp.query_o986pg_k$(tmp$ret$0, $completion);
  }), 1);
}
function PlacementTotalsPage$render$slambda$slambda$slambda_1($api, $placements) {
  return constructCallableReference(($this$async, $completion) => orPromise($completion, function *($completion) {
    var tmp = $api.get_careProvider_y0cmmt_k$();
    var tmp2 = 2147483647;
    // Inline function 'com.lightningkite.services.database.Query' call
    // Inline function 'kotlin.collections.listOf' call
    var orderBy = emptyList();
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_0 = serializerOrContextual(createKType(getKClass(CareProvider()), arrayOf([]), false));
    var tmp$ret$3 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
    var it = new (DataClassPathSelf())(tmp$ret$3);
    var tmp_1 = get__id_1(it);
    // Inline function 'kotlin.collections.map' call
    var this_0 = $placements;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var item = _iterator__ex2g4s.next_20eer_k$();
      var tmp$ret$7 = new (ID_3())(item.provider_1);
      destination.add_utx5q5_k$(tmp$ret$7);
    }
    var tmp$ret$4 = xDataClassPathInsideSet(tmp_1, toSet(destination));
    var tmp$ret$0 = new (Query())(tmp$ret$4, orderBy, 0, tmp2);
    return yield* tmp.query_o986pg_k$(tmp$ret$0, $completion);
  }), 1);
}
function PlacementTotalsPage$render$slambda$slambda$slambda_2($api, $placements) {
  return constructCallableReference(($this$async, $completion) => orPromise($completion, function *($completion) {
    var tmp = $api.get_employer_c2djlo_k$();
    var tmp2 = 2147483647;
    // Inline function 'com.lightningkite.services.database.Query' call
    // Inline function 'kotlin.collections.listOf' call
    var orderBy = emptyList();
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_0 = serializerOrContextual(createKType(getKClass(Employer()), arrayOf([]), false));
    var tmp$ret$3 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
    var it = new (DataClassPathSelf())(tmp$ret$3);
    var tmp_1 = get__id_2(it);
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0 = $placements;
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
    var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      var list = element.employers_1;
      addAll(destination, list);
    }
    var tmp$ret$4 = xDataClassPathInsideSet(tmp_1, toSet(destination));
    var tmp$ret$0 = new (Query())(tmp$ret$4, orderBy, 0, tmp2);
    return yield* tmp.query_o986pg_k$(tmp$ret$0, $completion);
  }), 1);
}
function PlacementTotalsPage$render$slambda$slambda$slambda_3($api, $placements) {
  return constructCallableReference(($this$async, $completion) => orPromise($completion, function *($completion) {
    var tmp = $api.get_grant_is33zn_k$();
    var tmp2 = 2147483647;
    // Inline function 'com.lightningkite.services.database.Query' call
    // Inline function 'kotlin.collections.listOf' call
    var orderBy = emptyList();
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_0 = serializerOrContextual(createKType(getKClass(Grant()), arrayOf([]), false));
    var tmp$ret$3 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
    var it = new (DataClassPathSelf())(tmp$ret$3);
    var tmp_1 = get__id_3(it);
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0 = $placements;
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
    var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      var list = element.grants_1;
      addAll(destination, list);
    }
    var tmp$ret$4 = xDataClassPathInsideSet(tmp_1, toSet(destination));
    var tmp$ret$0 = new (Query())(tmp$ret$4, orderBy, 0, tmp2);
    return yield* tmp.query_o986pg_k$(tmp$ret$0, $completion);
  }), 1);
}
function PlacementTotalsPage$render$slambda$slambda$lambda(it) {
  return it.get_key_18j28a_k$().first_1.order_1;
}
function PlacementTotalsPage$render$slambda$slambda$lambda_0(it) {
  return it.get_key_18j28a_k$().first_1.label_1;
}
function PlacementTotalsPage$render$slambda$slambda$lambda_1(it) {
  var tmp0_safe_receiver = it.get_key_18j28a_k$().second_1;
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.order_1;
}
function PlacementTotalsPage$render$slambda$slambda$lambda_2(it) {
  var tmp0_safe_receiver = it.get_key_18j28a_k$().second_1;
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.label_1;
}
function PlacementTotalsPage$render$slambda$slambda(this$0) {
  return constructCallableReference(($this$coroutineScope, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = this$0.filter_1;
    var f = yield* await_0(this_0, $completion);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = get_currentSessionNotNull();
    var api = (yield* await_1(this_1, $completion)).api_1;
    var placements = yield* api.get_childPlacement_o77pq_k$().query_o986pg_k$(new (Query())(f.placementCondition_859kcq_k$(), VOID, VOID, 2147483647), $completion);
    var familiesAsync = async($this$coroutineScope, VOID, VOID, PlacementTotalsPage$render$slambda$slambda$slambda(api, placements));
    var locationsAsync = async($this$coroutineScope, VOID, VOID, PlacementTotalsPage$render$slambda$slambda$slambda_0(api, placements));
    var providersAsync = async($this$coroutineScope, VOID, VOID, PlacementTotalsPage$render$slambda$slambda$slambda_1(api, placements));
    var employersAsync = async($this$coroutineScope, VOID, VOID, PlacementTotalsPage$render$slambda$slambda$slambda_2(api, placements));
    var grantsAsync = async($this$coroutineScope, VOID, VOID, PlacementTotalsPage$render$slambda$slambda$slambda_3(api, placements));
    // Inline function 'kotlin.collections.associateBy' call
    var this_2 = yield* familiesAsync.await_4rdzbx_k$($completion);
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_2, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity);
    var _iterator__ex2g4s = this_2.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      var tmp$ret$4 = new (ID_1())(element._id_1);
      destination.put_4fpzoq_k$(tmp$ret$4, element);
    }
    var families = destination;
    // Inline function 'kotlin.collections.associateBy' call
    var this_3 = yield* locationsAsync.await_4rdzbx_k$($completion);
    var capacity_0 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_3, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_0 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity_0);
    var _iterator__ex2g4s_0 = this_3.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
      var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
      var tmp$ret$7 = new (ID_2())(element_0._id_1);
      destination_0.put_4fpzoq_k$(tmp$ret$7, element_0);
    }
    var locations = destination_0;
    // Inline function 'kotlin.collections.associateBy' call
    var this_4 = yield* providersAsync.await_4rdzbx_k$($completion);
    var capacity_1 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_4, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_1 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity_1);
    var _iterator__ex2g4s_1 = this_4.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
      var element_1 = _iterator__ex2g4s_1.next_20eer_k$();
      var tmp$ret$10 = new (ID_3())(element_1._id_1);
      destination_1.put_4fpzoq_k$(tmp$ret$10, element_1);
    }
    var providers = destination_1;
    // Inline function 'kotlin.collections.associateBy' call
    var this_5 = yield* employersAsync.await_4rdzbx_k$($completion);
    var capacity_2 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_5, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_2 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity_2);
    var _iterator__ex2g4s_2 = this_5.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_2.hasNext_bitz1p_k$()) {
      var element_2 = _iterator__ex2g4s_2.next_20eer_k$();
      var tmp$ret$13 = new (ID())(element_2._id_1);
      destination_2.put_4fpzoq_k$(tmp$ret$13, element_2);
    }
    var employers = destination_2;
    // Inline function 'kotlin.collections.associateBy' call
    var this_6 = yield* grantsAsync.await_4rdzbx_k$($completion);
    var capacity_3 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_6, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_3 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity_3);
    var _iterator__ex2g4s_3 = this_6.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_3.hasNext_bitz1p_k$()) {
      var element_3 = _iterator__ex2g4s_3.next_20eer_k$();
      var tmp$ret$16 = new (ID_0())(element_3._id_1);
      destination_3.put_4fpzoq_k$(tmp$ret$16, element_3);
    }
    var grants = destination_3;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_7 = this$0.thenBy_1;
    var then = yield* await_0(this_7, $completion);
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination_4 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
    var _iterator__ex2g4s_4 = placements.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_4.hasNext_bitz1p_k$()) {
      var element_4 = _iterator__ex2g4s_4.next_20eer_k$();
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_8 = this$0.groupBy_1;
      var tmp$ret$21 = yield* await_0(this_8, $completion);
      // Inline function 'kotlin.collections.flatMap' call
      var tmp0 = render$groupsOf(families, f, locations, providers, employers, grants, element_4, tmp$ret$21);
      // Inline function 'kotlin.collections.flatMapTo' call
      var destination_5 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
      var _iterator__ex2g4s_5 = tmp0.iterator_jk1svi_k$();
      while (_iterator__ex2g4s_5.hasNext_bitz1p_k$()) {
        var element_5 = _iterator__ex2g4s_5.next_20eer_k$();
        var tmp;
        if (then == null) {
          tmp = listOf(new (Triple())(element_5, null, element_4));
        } else {
          // Inline function 'kotlin.collections.map' call
          var this_9 = render$groupsOf(families, f, locations, providers, employers, grants, element_4, then);
          // Inline function 'kotlin.collections.mapTo' call
          var destination_6 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_9, 10));
          var _iterator__ex2g4s_6 = this_9.iterator_jk1svi_k$();
          while (_iterator__ex2g4s_6.hasNext_bitz1p_k$()) {
            var item = _iterator__ex2g4s_6.next_20eer_k$();
            var tmp$ret$27 = new (Triple())(element_5, item, element_4);
            destination_6.add_utx5q5_k$(tmp$ret$27);
          }
          tmp = destination_6;
        }
        var list = tmp;
        addAll(destination_5, list);
      }
      var list_0 = destination_5;
      addAll(destination_4, list_0);
    }
    // Inline function 'kotlin.collections.groupBy' call
    // Inline function 'kotlin.collections.groupByTo' call
    var destination_7 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
    var _iterator__ex2g4s_7 = destination_4.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_7.hasNext_bitz1p_k$()) {
      var element_6 = _iterator__ex2g4s_7.next_20eer_k$();
      var key = to(element_6.first_1, element_6.second_1);
      // Inline function 'kotlin.collections.getOrPut' call
      var value = destination_7.get_wei43m_k$(key);
      var tmp_0;
      if (value == null) {
        var answer = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        destination_7.put_4fpzoq_k$(key, answer);
        tmp_0 = answer;
      } else {
        tmp_0 = value;
      }
      var list_1 = tmp_0;
      var tmp$ret$33 = element_6.third_1;
      list_1.add_utx5q5_k$(tmp$ret$33);
    }
    var tmp_1 = destination_7.get_entries_p20ztl_k$();
    var tmp_2 = PlacementTotalsPage$render$slambda$slambda$lambda;
    var tmp_3 = PlacementTotalsPage$render$slambda$slambda$lambda_0;
    var tmp_4 = PlacementTotalsPage$render$slambda$slambda$lambda_1;
    // Inline function 'kotlin.collections.map' call
    var this_10 = sortedWith(tmp_1, compareBy([tmp_2, tmp_3, tmp_4, PlacementTotalsPage$render$slambda$slambda$lambda_2]));
    // Inline function 'kotlin.collections.mapTo' call
    var destination_8 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_10, 10));
    var _iterator__ex2g4s_8 = this_10.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_8.hasNext_bitz1p_k$()) {
      var item_0 = _iterator__ex2g4s_8.next_20eer_k$();
      // Inline function 'kotlin.collections.component1' call
      var key_0 = item_0.get_key_18j28a_k$();
      // Inline function 'kotlin.collections.component2' call
      var ps = item_0.get_value_j01efc_k$();
      var outer = key_0.component1_7eebsc_k$();
      var inner = key_0.component2_7eebsb_k$();
      var tmp_5 = joinToString(listOfNotNull([outer.label_1, inner == null ? null : inner.label_1]), ' \xB7 ');
      var tmp_6 = ps.get_size_woubt6_k$();
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_9 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(ps, 10));
      var _iterator__ex2g4s_9 = ps.iterator_jk1svi_k$();
      while (_iterator__ex2g4s_9.hasNext_bitz1p_k$()) {
        var item_1 = _iterator__ex2g4s_9.next_20eer_k$();
        var tmp$ret$41 = new (ID_4())(item_1.child_1);
        destination_9.add_utx5q5_k$(tmp$ret$41);
      }
      var tmp$ret$36 = new (Row())(tmp_5, tmp_6, toSet(destination_9).get_size_woubt6_k$());
      destination_8.add_utx5q5_k$(tmp$ret$36);
    }
    return destination_8;
  }), 1);
}
function PlacementTotalsPage$render$slambda(this$0) {
  return constructCallableReference(($this$rememberSuspending, $completion) => orPromise($completion, function *($completion) {
    return yield* coroutineScope(PlacementTotalsPage$render$slambda$slambda(this$0), $completion);
  }), 1);
}
function PlacementTotalsPage$render$lambda_1($this$table, it) {
  return $this$table;
}
function PlacementTotalsPage$render$lambda_2($this$text) {
  return 'Group';
}
function PlacementTotalsPage$render$lambda_3($this$text, it) {
  return it.label_1;
}
function PlacementTotalsPage$render$lambda_4($this$text) {
  return 'Placements';
}
function PlacementTotalsPage$render$lambda_5($this$text, it) {
  return it.placements_1.toString();
}
function PlacementTotalsPage$render$lambda_6($this$text) {
  return 'Children';
}
function PlacementTotalsPage$render$lambda_7($this$text, it) {
  return it.children_1.toString();
}
function PlacementTotalsPage$render$lambda_8($this$shownWhen) {
  return get_current(Companion_instance_0).equals(Platform_Web_getInstance());
}
var PlacementTotalsPageClass;
function PlacementTotalsPage() {
  if (PlacementTotalsPageClass === VOID) {
    class $ {
      constructor() {
        this.filter_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(new (ReportFilters())());
        this.groupBy_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(PlacementGrouping_AgeGroup_getInstance());
        this.thenBy_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(PlacementGrouping_LocationType_getInstance());
      }
      get_title_iz32un_k$() {
        return new (Constant())(_Constant___init__impl__v45mub('Placement Totals'));
      }
      render_w3x9d1_k$(_this__u8e3s4) {
        // Inline function 'org.thecommunitygroupinc.cares.views.components.page' call
        var this_0 = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_1 = maxWidth(this_0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element);
        this_1.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(true);
        element.set_themeBase_daz04n_k$(Companion_getInstance().fromParentNonCascading_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        element.willAddChild_hz2iwc_k$(element_0);
        element_0.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_2 = get_atBottomStart(element_0);
        var tmp$ret$10 = weight(this_2, 1.0);
        h1(tmp$ret$10, 'Placement Totals');
        reportFilterMenu(element_0, this.filter_1);
        element_0.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_0);
        reportFilterBar(element, this.filter_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = new (RowOrCol())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        element.willAddChild_hz2iwc_k$(element_1);
        element_1.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var tmp0 = weight(element_1, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.l2.label' call
        var label = 'Group by';
        // Inline function 'com.lightningkite.kiteui.views.l2.label' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(tmp0.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        tmp0.willAddChild_hz2iwc_k$(element_2);
        element_2.set_content_lzqutq_k$(label);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        // Inline function 'com.lightningkite.kiteui.views.direct.select' call
        var this_3 = themed(element_2, FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_3 = new (Select())(this_3.get_context_h02k06_k$());
        ensureOutermostElement(element_3);
        this_3.willAddChild_hz2iwc_k$(element_3);
        var tmp = _Constant___init__impl__v45mub(get_entries());
        element_3.bind_64a41i_k$(this.groupBy_1, new (Constant())(tmp), PlacementTotalsPage$render$lambda);
        element_3.onStartup_vrxh3i_k$();
        this_3.addChild_2qpft2_k$(element_3);
        element_2.onStartup_vrxh3i_k$();
        tmp0.addChild_2qpft2_k$(element_2);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        // Inline function 'com.lightningkite.kiteui.views.l2.label' call
        // Inline function 'com.lightningkite.kiteui.views.l2.label' call
        var this_4 = weight(element_1, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_4 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(this_4.get_context_h02k06_k$());
        ensureOutermostElement(element_4);
        this_4.willAddChild_hz2iwc_k$(element_4);
        element_4.set_content_lzqutq_k$('Then by');
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        // Inline function 'com.lightningkite.kiteui.views.direct.select' call
        var this_5 = themed(element_4, FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_5 = new (Select())(this_5.get_context_h02k06_k$());
        ensureOutermostElement(element_5);
        this_5.willAddChild_hz2iwc_k$(element_5);
        var tmp_0 = _Constant___init__impl__v45mub(plus(listOf(null), get_entries()));
        element_5.bind_64a41i_k$(this.thenBy_1, new (Constant())(tmp_0), PlacementTotalsPage$render$lambda_0);
        element_5.onStartup_vrxh3i_k$();
        this_5.addChild_2qpft2_k$(element_5);
        element_4.onStartup_vrxh3i_k$();
        this_4.addChild_2qpft2_k$(element_4);
        element_1.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_1);
        var rows = rememberSuspending(VOID, VOID, VOID, PlacementTotalsPage$render$slambda(this));
        var tmp_1 = PlacementTotalsPage$render$lambda_1;
        var tmp_2 = Companion_instance_1;
        var tmp_3 = PlacementTotalsPage$render$lambda_2;
        var tmp_4 = tmp_2.text_y5ktm4_k$(tmp_3, 2.0, PlacementTotalsPage$render$lambda_3);
        var tmp_5 = Companion_instance_1;
        var tmp_6 = PlacementTotalsPage$render$lambda_4;
        var tmp_7 = tmp_5.text_y5ktm4_k$(tmp_6, 0.5, PlacementTotalsPage$render$lambda_5);
        var tmp_8 = Companion_instance_1;
        var tmp_9 = PlacementTotalsPage$render$lambda_6;
        table(element, rows, tmp_1, [tmp_4, tmp_7, tmp_8.text_y5ktm4_k$(tmp_9, 0.5, PlacementTotalsPage$render$lambda_7)]);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        var this_6 = shownWhen(element, VOID, VOID, PlacementTotalsPage$render$lambda_8);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_6 = new (Space())(this_6.get_context_h02k06_k$(), 1.0);
        ensureOutermostElement(element_6);
        this_6.willAddChild_hz2iwc_k$(element_6);
        element_6.onStartup_vrxh3i_k$();
        this_6.addChild_2qpft2_k$(element_6);
        element.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element);
        return Unit_instance;
      }
    }
    initMetadataForClass($, 'PlacementTotalsPage', PlacementTotalsPage, VOID, [Page()]);
    PlacementTotalsPageClass = $;
  }
  return PlacementTotalsPageClass;
}
function PlacementGrouping_Payer_getInstance() {
  static_init();
  return PlacementGrouping_Payer_instance;
}
function PlacementGrouping_Family_getInstance() {
  static_init();
  return PlacementGrouping_Family_instance;
}
function PlacementGrouping_AgeGroup_getInstance() {
  static_init();
  return PlacementGrouping_AgeGroup_instance;
}
function PlacementGrouping_Location_getInstance() {
  static_init();
  return PlacementGrouping_Location_instance;
}
function PlacementGrouping_Provider_getInstance() {
  static_init();
  return PlacementGrouping_Provider_instance;
}
function PlacementGrouping_LocationType_getInstance() {
  static_init();
  return PlacementGrouping_LocationType_instance;
}
//region block: exports
export {
  PlacementGrouping_Location_getInstance as PlacementGrouping_Location_getInstanceajmolhamx7a,
  PlacementGrouping as PlacementGrouping39ofupa5wg0i5,
  PlacementTotalsPage as PlacementTotalsPage1pmi1f9h9gb4a,
};
//endregion

//# sourceMappingURL=PlacementTotalsPage.mjs.map
